export const cancellationSurveyReasonCodes = {
  TEMPORARY: 'temporary',
  COST: 'cost',
  UNUSED_LICENSES: 'unused-licenses',
  ALTERNATIVE: 'alternative',
  TECHNICAL: 'technical',
  NO_LONGER_NEED: 'no-longer-need',
  CUSTOMER_SERVICE: 'customer-service',
  OTHER: 'other',
} as const;

export type CancellationReason =
  (typeof cancellationSurveyReasonCodes)[keyof typeof cancellationSurveyReasonCodes];

export type CancellationSurveyResponse = {
  reason: CancellationReason | null;
  context: string;
};
